module.exports = __webpack_public_path__ + "static/media/hero.6961a303.webp";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/hero.webp
// module id = 45
// module chunks = 1